import { Client } from '@opanuj/shared/types';
import { LoadingHook, useLoadingValue } from 'react-firebase-hooks/util';
import { useClientsList } from './useClients';
import { useEffect } from 'react';
import { useUser } from './useUser';

export const useCurrentClient = (): LoadingHook<Client, Error> => {
	const { error, loading, setError, setValue, value } = useLoadingValue<Client, Error>();
	const [user, userLoading, userError] = useUser()
	const [clients, clientsLoading, clientsError] = useClientsList()
	
	useEffect(() => {
		if (userLoading || clientsLoading) {
			return;
		}
		if (userError) {
			setError(userError);
			return;
		}
		if (clientsError) {
			setError(clientsError);
			return;
		}
		if (!user) {
			setValue();
			return;
		}
		const client = clients.find((c) => c.uid === user.uid);
		if (!client) {
			setError(new Error('Client matching logged user not found'));
			return;
		}
		setValue(client);

	}, [user, userLoading, userError, clients, clientsLoading, clientsError, setError, setValue]);

	return [value, loading, error];
}